<div class="flex w-full items-center justify-center">
  <proffeo-ui-select
    (valueChange)="onPriorityChange($event)"
    [disabled]="readonly()"
    [optionTemplate]="priorityOptionTemplate"
    [options]="priorityOptions"
    [triggerTemplate]="priorityTriggerTemplate"
    [value]="selectedPriority()"
    appearance="inline"
  />
</div>

<ng-template
  #priorityTriggerTemplate
  let-selectedOptions="selectedOptions"
>
  @if (selectedOptions[0]; as selectedOption) {
    <proffeo-ui-priority-badge
      [density]="badgeDensity()"
      [priority]="selectedOption.value"
      [showLabel]="!small()"
    />
  }
</ng-template>

<ng-template
  #priorityOptionTemplate
  let-option="option"
>
  <proffeo-ui-priority-badge
    [density]="badgeDensity()"
    [priority]="option.value"
    [showLabel]="true"
  />
</ng-template>
